export const MASTER_BLOG_CATEGORY_PREFIX = "master:";

const getModelId = (value) => value?._id || value?.id || value;

export const getMasterBlogCategoryValue = (masterCategory) => {
  const id = getModelId(masterCategory);
  return id ? `${MASTER_BLOG_CATEGORY_PREFIX}${id}` : "";
};

export const blogCategoryOptions = [];

export const getBlogCategoryValueFromBlog = (blog) => {
  return getMasterBlogCategoryValue(blog?.masterCategoryId);
};

export const getBlogCategoryLabel = (
  value,
  fallbackLabel = "Blog",
  categoryOptions = blogCategoryOptions,
) => {
  const normalizedValue = String(value || "");
  const categoryOption = categoryOptions.find(
    (category) => category.value === normalizedValue,
  );

  if (categoryOption?.label) return categoryOption.label;
  if (normalizedValue.startsWith(MASTER_BLOG_CATEGORY_PREFIX)) return fallbackLabel;
  return normalizedValue || fallbackLabel;
};

export const getBlogCategoryLabelFromBlog = (
  blog,
  fallbackLabel = "Blog",
  categoryOptions = blogCategoryOptions,
) => {
  if (
    blog?.masterCategoryId &&
    typeof blog.masterCategoryId === "object" &&
    blog.masterCategoryId.name
  ) {
    return blog.masterCategoryId.name;
  }

  return getBlogCategoryLabel(
    getBlogCategoryValueFromBlog(blog),
    fallbackLabel,
    categoryOptions,
  );
};

export default blogCategoryOptions;
